import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../shared/services/common.service';
import { CookieService } from '../../shared/services/cookie.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  constructor(
    private router: Router,
    private commonSvc: CommonService,
    private cookieService: CookieService
  ) { }

  public isAuthenticated(): boolean {
    // Check if token exists in cookies
    return this.cookieService.hasCookie('token');
  }

  public onLogout(): void {
    // Clear token cookies
      this.cookieService.deleteCookie('token');
    // Clear localStorage
    localStorage.clear();
    this.router.navigate(['auth/login']);
    this.commonSvc.message.success('Logged out successfully', { nzDuration: 3000 });
  }
}
